import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const PageTitle = styled.div`
    font-weight: bold;
    font-size: ${theme.font.size20};
    color: ${(props) => props.theme.black};
    margin: 0 0 8px 0;
`;

export const ContainerDownload = styled.div`
    display: flex;
    align-items: center;
    height: 56px;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 12px 22px;
    margin: 0 0 32px 0;
`;

export const Title = styled.div`
    color: #5B5B5F;
    font-weight: bold;
    font-size: ${theme.font.size14};
    margin-left: 10px;
`;

export const BtnDownload = styled.div`
    font-size: ${theme.font.size16};
    font-weight: bold;
    color: #EC6E0C;
    cursor: pointer;
    text-decoration: underline #EC6E0C ; 
`;

export const SpacingCard = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
